import React from 'react'

const Loading = () => {
  return (

    
    <div className='loading d-flex justify-content-center align-items-center'>
        <div className='text-center text-light'>
        <h1 className='fw-bold'>Taste the Creativity</h1>
        <p className='fs-6 text-white-50'>We make awesome graphic and web design</p>
        <button className='btn btn-danger py-2 my-4 px-4'>Get Started</button>
    
        </div>
    </div>
  )
}

export default Loading